<template>
  <v-container class="task-dashboard">
    <DataTablePaginated
        ref="table"
        class="ma-1"
        :headers="headers"
        icon="visibility"
        :iconTooltip="$t('buttons:view')"
        @updateTableData="updateTable"
        :addBtn="true"
        :addBtnText="$t('buttons:add-specific', {specific: $t('common:task')})"
        @clickedAddButton="createTask"
        sortBy="incidentDate"
        :sortDesc="true"
        :items-per-page="10"
        @clickedButton1="v => $refs.taskReview.openDialog(v)"
    />
    <AddTaskDialog ref="taskForm" @closeDialog="loadTasks" facility-unchangeable />
    <ViewTaskDialog ref="taskReview" @closeDialog="loadTasks" facility-window />
  </v-container>
</template>
<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import TaskBoardService from '@/modules/book/services/task-board-service';
import ViewTaskDialog from '@/modules/book/views/task/ViewTaskDialog.vue';
import AddTaskDialog from '@/modules/book/views/task/AddTaskDialog.vue';
import FacilityService from '@/modules/book/services/facility-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: 'FacilityTaskBoard',
  components: {ViewTaskDialog, AddTaskDialog, DataTablePaginated},
  props: {
    facilityId: String,
  },
  computed: {
    headers() {
      return [
        { text: this.$t('common:name'), value: 'name', sortable:true },
        { text: this.$t('book/issue:add-issue-form.task-date'), value: 'incidentDate', sortable:true },
        { text: this.$t('book/issue:common.appointment-date'), value: 'appointmentDate', sortable:true },
        { text: this.$t('book/issue:status.TASK_STATUS'), value: 'taskStatusString', sortable:true },
        { text: this.$t('common:elevator'), value: 'facilityName', sortable:true },
        { text: '', value: 'controls'}
      ];
    }
  },
  data() {
    return {
      facility: null
    }
  },
  methods: {
    updateTable(options, search) {
      if (!this.facilityId) return;

      if(!search) search = '';

      TaskBoardService.readAllPaginatedByFacilityFromAPI(
          this.facilityId,
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            this.$refs.table.fillTableData(response.data);
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}))
            this.$logger.error(error);
          }
      );
    },
    loadFacilityInfo() {
      if (!this.facilityId) return;

      FacilityService.readByIdFromAPI(
          this.facilityId,
          (response) => {
            this.facility = response.data;
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:facility')}))
            this.$logger.error(error);
          }
      );
    },
    loadTasks() {
      this.$refs.table.callTableUpdate();
    },
    createTask() {
      this.$refs.taskForm.openDialog({
        'facility': this.facility.id,
        'company': this.facility.manager
      });
    }
  },
  created() {
    this.loadFacilityInfo();
  }
}
</script>